import { getCurrentInstance, ref, inject, InjectionKey } from 'vue';

const ViewportSizeKey: InjectionKey<ViewportSize> = Symbol.for('travelplanner:viewportSize');

class ViewportSize {
    height = ref(window.visualViewport?.height || window.innerHeight);
    width = ref(window.visualViewport?.width || window.innerWidth);

    constructor() {
        // this is required because the Window object does not emit the 'resize' event in Safari iOS, but window.visualViewport does
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', () => {
                const { height, width } = window.visualViewport!;
                this.height.value = height;
                this.width.value = width;
            });
        } else {
            window.addEventListener('resize', () => {
                const { innerHeight: height, innerWidth: width } = window;
                this.height.value = height;
                this.width.value = width;
            });
        }
    }
}

export function useViewportSize() {
    const instance = getCurrentInstance();
    if (!instance) throw new Error('useViewport must be called from inside a setup function.');

    const app = instance.root.appContext.app;

    let viewportSize = inject(ViewportSizeKey, { width: ref(375), height: ref(375) });
    if (!viewportSize) {
        app.provide(ViewportSizeKey, (viewportSize = new ViewportSize()));
    }

    return {
        ...viewportSize
    };
}
